//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// OTP
export const POST_OTP_VERIFY = "/auth/verify-otp";
export const POST_OTP_RESEND = "/auth/resend-otp";

// ROLES (using Profile endpoint)
export const GET_ROLES = "/Profile";
export const POST_ROLE = "/Role";
export const PUT_ROLE = "/Role";
export const DELETE_ROLE = "/Role";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";
export const GET_PROFILES = "/Profile"; // Super Admin profiles
export const GET_TENANT_PROFILES = "/Profile/Tenant"; // Tenant user profiles
export const GET_CLIENT_PROFILES = "/Profile/Client"; // Client user profiles
export const POST_PROFILE = "/Profile";
export const PUT_PROFILE = "/Profile";
export const DELETE_PROFILE = "/Profile";

//DEPARTMENTS
export const GET_DEPARTMENTS = "/Department";
export const POST_DEPARTMENT = "/Department";
export const PUT_DEPARTMENT = "/Department";
export const DELETE_DEPARTMENT = "/Department";

// LEADS
export const GET_LEADS = "/Lead";
export const GET_LEADS_BY_STATUS = "/Lead/ByStatus";
export const ADD_NEW_LEAD = "/Lead";
export const ADD_NEW_LEAD_WITH_ATTACHMENTS = "/Lead/WithAttachments";
export const UPDATE_LEAD = "/Lead";
export const DELETE_LEAD = "/Lead";
export const APPROVE_LEAD = "/Lead/Approve";
export const CONVERT_LEAD_TO_CLIENT = "/Lead/ConvertToClient";
export const CHURN_LEAD = "/Lead/Churn";

// LEAD ATTACHMENTS
export const GET_LEAD_ATTACHMENTS = "/LeadAttachment/Lead"; // Base path, append /{leadId}
export const ADD_LEAD_ATTACHMENT = "/LeadAttachment";
export const DELETE_LEAD_ATTACHMENT = "/LeadAttachment";

// CLIENTS
export const GET_CLIENTS = "/Client";
export const ADD_NEW_CLIENT = "/Client";
export const UPDATE_CLIENT = "/Client";
export const DELETE_CLIENT = "/Client";

// SUPPLIERS
export const GET_SUPPLIERS = "/Supplier/tenant";
export const GET_SUPPLIERS_ACTIVE = "/Supplier/tenant";
export const GET_SUPPLIER_BY_ID = "/Supplier";
export const CREATE_SUPPLIER = "/Supplier";
export const UPDATE_SUPPLIER = "/Supplier";
export const DELETE_SUPPLIER = "/Supplier";

// CLIENT CONTACTS
export const GET_CLIENT_CONTACTS = "/ClientContact";
export const ADD_NEW_CLIENT_CONTACT = "/ClientContact";
export const UPDATE_CLIENT_CONTACT = "/ClientContact";
export const DELETE_CLIENT_CONTACT = "/ClientContact";

// COUNTRIES
export const GET_COUNTRIES = "/Country";

// CLIENT SITES
export const GET_CLIENT_SITES = "/ClientSite";
export const GET_CLIENT_SITE_BY_ID = "/ClientSite";
export const ADD_NEW_CLIENT_SITE = "/ClientSite";
export const CREATE_CLIENT_SITE_WITH_ATTACHMENTS = "/ClientSite/WithAttachments";
export const UPDATE_CLIENT_SITE = "/ClientSite";
export const UPDATE_CLIENT_SITE_WITH_ATTACHMENTS = "/ClientSite";
export const DELETE_CLIENT_SITE = "/ClientSite";

// CLIENT SITE ATTACHMENTS
export const GET_CLIENT_SITE_ATTACHMENTS = "/ClientSiteAttachment/ClientSite";
export const ADD_CLIENT_SITE_ATTACHMENT = "/ClientSiteAttachment";
export const DELETE_CLIENT_SITE_ATTACHMENT = "/ClientSiteAttachment";

// TENANT
export const GET_TENANT_BY_ID = "/Tenant";

// TENANT RENTAL CONFIGURATION
export const GET_TENANT_RENTAL_CONFIG = "/TenantRentalConfiguration";
export const UPDATE_TENANT_RENTAL_CONFIG = "/TenantRentalConfiguration";

// TENANT LOCATIONS
export const GET_TENANT_LOCATIONS = "/TenantLocation";
export const ADD_NEW_TENANT_LOCATION = "/TenantLocation";
export const UPDATE_TENANT_LOCATION = "/TenantLocation";
export const DELETE_TENANT_LOCATION = "/TenantLocation";

// TENANT ROLES
export const GET_TENANT_ROLES = "/Role";
export const POST_TENANT_ROLE = "/Role";
export const PUT_TENANT_ROLE = "/Role";
export const DELETE_TENANT_ROLE = "/Role";

// CLIENT RENTAL CONFIGURATION
export const CLIENT_RENTAL_CONFIG = "/ClientRentalConfiguration";

// USER PROFILE IMAGE (self-service avatar)
export const MANAGE_PROFILE_IMAGE = "/User/ManageProfileImage"; // PUT ?id={userId}, multipart "profileImage"
export const DELETE_USER_PROFILE_IMAGE = "/User/DeleteUserProfileImage"; // DELETE /{userId}

// GLOBAL USERS (User Management)
export const GET_GLOBAL_USERS = "/User/TenantUser";
export const ADD_NEW_GLOBAL_USER = "/User/TenantUser";
export const UPDATE_GLOBAL_USER = "/User/TenantUser";
export const DELETE_GLOBAL_USER = "/User/TenantUser";

// Profile-Based User APIs (NEW)
// These APIs filter users by ProfileId (system-defined profiles), not RoleId (tenant-defined roles)
export const GET_TENANT_FIELD_USERS = "/User/TenantUser/FieldUser";
export const GET_TENANT_MANAGERS = "/User/TenantUser/Manager";
export const POST_USERS_BY_PROFILE_IDS = "/User/TenantUser/SpecificProfileUsers";

// CLIENT MEETINGS
export const GET_CLIENT_MEETINGS = "/ClientMeeting";
export const GET_CLIENT_MEETING_BY_ID = "/ClientMeeting";
export const GET_CLIENT_MEETING_FOR_EDIT = "/ClientMeeting";
export const ADD_NEW_CLIENT_MEETING = "/ClientMeeting";
export const UPDATE_CLIENT_MEETING = "/ClientMeeting";
export const UPDATE_CLIENT_MEETING_FOR_EDIT = "/ClientMeeting";
export const RESCHEDULE_CLIENT_MEETING = "/ClientMeeting";
export const CANCEL_CLIENT_MEETING = "/ClientMeeting";
export const COMPLETE_CLIENT_MEETING = "/ClientMeeting";
export const DELETE_CLIENT_MEETING = "/ClientMeeting";
export const DELETE_CLIENT_MEETING_ATTACHMENT = "/ClientMeetingAttachment";

// PRODUCTS
export const GET_PRODUCTS = "/Product";
export const ADD_NEW_PRODUCT = "/Product";
export const UPDATE_PRODUCT = "/Product";
export const DELETE_PRODUCT = "/Product";

// INVENTORY (Stock Items)
export const GET_STOCK_ITEMS = "/Inventory";
export const GET_INVENTORY_BY_ID = "/Inventory";
export const ADD_NEW_STOCK_ITEM = "/Inventory";
export const UPDATE_STOCK_ITEM = "/Inventory";
export const DELETE_STOCK_ITEM = "/Inventory";
export const RECEIVE_STOCK = "/Inventory/receive";
export const ISSUE_STOCK = "/Inventory/issue";
export const ADJUST_STOCK = "/Inventory/adjust";
export const GET_LOW_STOCK_ITEMS = "/Inventory/low-stock/tenant";
export const GET_STOCK_MOVEMENTS = "/Inventory/movements/product";
export const GET_INVENTORY_DASHBOARD = "/Inventory/dashboard";

// PURCHASE ORDERS
export const GET_PURCHASE_ORDERS = "/PurchaseOrder/tenant";
export const GET_PURCHASE_ORDER_BY_ID = "/PurchaseOrder";
export const CREATE_PURCHASE_ORDER = "/PurchaseOrder";
export const UPDATE_PURCHASE_ORDER = "/PurchaseOrder";
export const DELETE_PURCHASE_ORDER = "/PurchaseOrder";
export const APPROVE_PURCHASE_ORDER = "/PurchaseOrder";
export const RECEIVE_PURCHASE_ORDER = "/PurchaseOrder";
export const CANCEL_PURCHASE_ORDER = "/PurchaseOrder";
export const GET_PURCHASE_ORDERS_BY_SUPPLIER = "/PurchaseOrder/supplier";
export const ADD_PO_LINE_ITEM = "/PurchaseOrder/line-item";
export const UPDATE_PO_LINE_ITEM = "/PurchaseOrder/line-item";
export const DELETE_PO_LINE_ITEM = "/PurchaseOrder/line-item";

// QUOTES
export const GET_QUOTES = "/Quote";
export const GET_QUOTE_BY_ID = "/Quote";
export const ADD_NEW_QUOTE = "/Quote";
export const UPDATE_QUOTE = "/Quote";
export const DELETE_QUOTE = "/Quote";
export const GET_QUOTE_ACTIONS = "/Quote";
export const EXECUTE_QUOTE_ACTION = "/Quote";

// WORK ORDERS
export const GET_WORK_ORDERS = "/WorkOrder";
export const GET_WORK_ORDER_BY_ID = "/WorkOrder";
export const CREATE_WORK_ORDER = "/WorkOrder";
export const UPDATE_WORK_ORDER = "/WorkOrder";
export const DELETE_WORK_ORDER = "/WorkOrder";
export const GENERATE_WORK_ORDER_NUMBER = "/WorkOrder/GenerateWorkOrderNumber";
export const AUTOGENERATE_WORK_ORDER_NUMBER = "/WorkOrder/AutogenerateWorkOrderNumber";
export const CREATE_WORK_ORDER_WITH_ATTACHMENTS = "/WorkOrder/WithAttachments";
export const UPDATE_WORK_ORDER_WITH_ATTACHMENTS = "/WorkOrder";

// WORK ORDER ATTACHMENTS
export const GET_WORK_ORDER_ATTACHMENTS = "/WorkOrderAttachment";
export const ADD_WORK_ORDER_ATTACHMENT = "/WorkOrderAttachment";
export const DELETE_WORK_ORDER_ATTACHMENT = "/WorkOrderAttachment";

// JOBS
export const GET_JOBS = "/Job";
export const GET_JOB_BY_ID = "/Job";
export const CREATE_JOB = "/Job";
export const UPDATE_JOB = "/Job";
export const GET_JOBS_BY_CLIENT = "/Job/by-client";
export const GET_JOBS_BY_SITE = "/Job/by-site";
export const GET_JOB_BY_QUOTE_ID = "/Job/by-quote";
export const AUTOGENERATE_JOB_NUMBER = "/Job/AutogenerateJobNumber";

// SCAFFOLDS
export const GET_SCAFFOLDS = "/Scaffold";
export const CHANGE_SCAFFOLD_STATUS = "/Scaffold"; // Used as base, append /{id}/status

// SYSTEM ENUMS
export const GET_ADJUSTMENT_REASONS = "/SystemEnum/AdjustmentReason";
export const GET_ASSET_CLASS = "/SystemEnum/AssetClass";
export const GET_ASSET_STATUS = "/SystemEnum/AssetStatus";
export const GET_VEHICLE_TYPE = "/SystemEnum/VehicleType";
export const GET_IOT_PROVIDER_CODE = "/SystemEnum/IoTProviderCode";

// DASHBOARD
export const GET_DASHBOARD_ADMIN = "/Dashboard/Admin";

// ASSETS
export const GET_ASSETS = "/Asset/tenant"; // Append /{tenantId}
export const GET_ASSET_BY_ID = "/Asset";
export const CREATE_ASSET = "/Asset";
export const UPDATE_ASSET = "/Asset";
export const DELETE_ASSET = "/Asset";

// SITE TYPES
export const GET_SITE_TYPES = "/sitetype";
export const ADD_NEW_SITE_TYPE = "/sitetype";
export const UPDATE_SITE_TYPE = "/sitetype";
export const DELETE_SITE_TYPE = "/sitetype";

// PLANNER
export const GET_PLANNER_CARDS = "/Planner/cards";
export const GET_PLANNER_ACTIVITY = "/Planner"; // GET /api/v1/planner/{id}
export const GET_PLANNER_MONTH_SUMMARY = "/Planner/month";
export const GET_PLANNER_CREW_LOAD = "/Planner/crew-load";
export const GET_PLANNER_ASSET_LOAD = "/Planner/asset-load";
export const POST_PLANNER_ACTIVITY = "/Planner"; // POST /api/v1/planner
export const PUT_PLANNER_ACTIVITY = "/Planner"; // PUT /api/v1/planner/{id}
export const PATCH_PLANNER_REORDER = "/Planner/reorder";
export const PATCH_PLANNER_BASE = "/Planner"; // Base path for PATCH operations: /Planner/{id}/time, /Planner/{id}/crew, /Planner/{id}/assets
export const PATCH_PLANNER_CREW_MEMBER = "/Planner"; // Base for /Planner/{id}/crew-member
export const PATCH_PLANNER_ASSET = "/Planner"; // Base for /Planner/{id}/asset
export const GET_PLANNER_UNPLANNED_WORK = "/Planner/unplanned-work";
export const POST_PLANNER_FROM_UNPLANNED_TASK = "/Planner/from-unplanned-task";
export const GET_PLANNER_EXECUTION_LINES = "/Planner"; // Base for /Planner/{id}/execution-lines
export const POST_PLANNER_EXECUTION_LINES = "/Planner"; // Base for /Planner/{id}/execution-lines
export const DELETE_PLANNER_EXECUTION_LINE = "/Planner/execution-lines"; // Base for /Planner/execution-lines/{executionLineId}
export const DELETE_PLANNER_ACTIVITY = "/Planner"; // Base for /Planner/{id}
export const DELETE_PLANNER_CREW_ASSIGNMENT = "/Planner/crew-assignment"; // Base for /Planner/crew-assignment/{assignmentId}
export const DELETE_PLANNER_ASSET_ASSIGNMENT = "/Planner/asset-assignment"; // Base for /Planner/asset-assignment/{assignmentId}
export const GET_PLANNER_SUGGESTIONS = "/Planner/suggestions";
export const POST_PLANNER_FROM_UNPLANNED_TASK_GROUP = "/Planner/from-unplanned-task-group";
export const POST_PLANNER_CLONE = "/Planner"; // Base for /Planner/{id}/clone
export const GET_PLANNER_SITE_WORKLOAD = "/Planner/site-workload";
export const POST_PLANNER_CREW_REMOVE_FROM_DAY = "/Planner/crew/remove-from-day";
export const POST_PLANNER_CREW_REPLACE_IN_DAY = "/Planner/crew/replace-in-day";